/**
 * Onboarding progress - pure async functions, no React
 */

import { supabase } from "@/integrations/supabase/client";

export interface SectionStatus {
  status?: string;
  completedAt?: string;
}

export interface OnboardingProgressData {
  sections_completed: Record<string, unknown> & {
    phase2?: Record<string, SectionStatus>;
  };
  completed_at: string | null;
  current_section?: number;
}

export async function getOnboardingProgress(
  companyId: string
): Promise<OnboardingProgressData | null> {
  const { data, error } = await supabase
    .from("onboarding_progress")
    .select("sections_completed, completed_at, current_section")
    .eq("company_id", companyId)
    .single();

  if (error) {
    if (error.code === "PGRST116") return null;
    console.error("Error loading onboarding progress:", error);
    return null;
  }

  return {
    sections_completed: (data?.sections_completed as OnboardingProgressData["sections_completed"]) ?? {},
    completed_at: data?.completed_at ?? null,
    current_section: data?.current_section,
  };
}
